import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './assets/css/main.css';
import './assets/css/style.css';
import { ToastContainer } from 'react-toastify';
import { BASE_PATH } from './config/config';

const Home = lazy(() => import('./components/home'));
const Nav = lazy(() => import('./components/nav/nav'));
const Checkup = lazy(() => import('./components/checkup'));
const ResultsPage = lazy(() => import('./components/resultsPage'));
const DoctorList = lazy(() => import('./components/doctorList'));

const path = BASE_PATH;

function App() {
  return (
    <Router>
      <div className="App">
        <Nav />
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Suspense fallback={<div className='loader-bg'><div className='loader-bar'></div></div>}>
        <Routes>
          <Route path={`${path}/`} element={<Home />} />
          <Route path={`${path}/home`} element={<Home />} />
          <Route path={`${path}/checkup`} element={<Checkup />} />
          <Route path={`${path}/results`} element={<ResultsPage />} />
          <Route path={`${path}/doctorList`} element={<DoctorList />} />
        </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
